import { render } from "./HermesStatusBadge.vue?vue&type=template&id=79c55d0c&scoped=true"
import script from "./HermesStatusBadge.vue?vue&type=script&lang=js"
export * from "./HermesStatusBadge.vue?vue&type=script&lang=js"

import "./HermesStatusBadge.vue?vue&type=style&index=0&id=79c55d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c55d0c"]])

export default __exports__